import {
    Component,
    EventEmitter,
    TemplateRef,
    Input,
    Output
} from '@angular/core';

@Component({
    selector: 'pm-line-chart',
    //templateUrl: './app/controls/components/chart/line-chart/line-chart.html'
    templateUrl: './line-chart.html',
})
export class LineChartComponent {

}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/chart/line-chart/line-chart-component.ts